export const ELEMENT_IDENTIFIER = {
  PREVIEW: 'preview-container',
} as const;
